import { render, staticRenderFns } from "./SelectAttore.vue?vue&type=template&id=63800916&"
import script from "./SelectAttore.vue?vue&type=script&lang=ts&"
export * from "./SelectAttore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports